import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./icon-cards.module.css"
import classNames from "classnames"

export default function IconCards({ block }) {
  const gap = block?.attrs?.blockGap || "normal"

  if (block.innerBlocks.length === 0) {
    return null
  }

  return (
    <Block
      block={block}
      width="bleed"
      innerWrapper={true}
      gap={gap}
      className={classNames(
        styles.wrapper,
        "bg-color-" + (block?.attrs?.bgColor ?? "transparent")
      )}>
      <BlockHeader
        heading={block?.attrs?.heading}
        text={block?.attrs?.text}
        align={block?.attrs?.align}
      />
      <div
        className={classNames(
          "icon-card-grid",
          "cards-" + Math.min(block.innerBlocks.length, 4)
        )}>
        <Blocks blocks={block.innerBlocks} />
      </div>
    </Block>
  )
}
